import { render, staticRenderFns } from "./listPropertyRightRegistrationDetailList.vue?vue&type=template&id=386b4f1b&scoped=true"
import script from "./listPropertyRightRegistrationDetailList.vue?vue&type=script&lang=js"
export * from "./listPropertyRightRegistrationDetailList.vue?vue&type=script&lang=js"
import style0 from "./listPropertyRightRegistrationDetailList.vue?vue&type=style&index=0&id=386b4f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b4f1b",
  null
  
)

export default component.exports